import React from "react";
import { FormGroupWrapper } from "./styled";

const FormGroup: React.FC = ({ children }) => {
  return <FormGroupWrapper>{children}</FormGroupWrapper>;
};

export default FormGroup;
